module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "title": "Frontmatter"
    }
  }, [_c('p', {
    staticClass: "noindent_para_ts1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('i', [_vm._v("And early in the morning he came walking toward them on the sea. But when the disciples saw him walking on the sea, they were terrified, saying, “It is a ghost!” And they cried out in fear. But immediately Jesus spoke to them and said, “Take heart, it is I; do not be afraid.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para_ts"
  }, [_c('i', [_vm._v("Peter answered him, “Lord, if it is you, command me to come to you on the water.” He said, “Come.” So Peter got out of the boat, started walking on the water, and came toward Jesus. But when he noticed the strong wind, he became frightened, and beginning to sink, he cried out, “Lord, save me!” Jesus immediately reached out his hand and caught him, saying to him, “You of little faith, why did you doubt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para_ts"
  }, [_c('i', [_vm._v("When they got into the boat, the wind ceased. And those in the boat worshiped him, saying, “Truly you are the Son of God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3"
  }, [_vm._v("Matthew 14:25–32")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037406d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310296065_Frontmatter.vue
// module id = 78
// module chunks = 0